document.addEventListener("DOMContentLoaded", function () {
  $(function () {
    $(".reward-program-faqs-title").click(function () {
      const $btn = $(this);
      const $panel = $btn.next(".reward-program-faqs-subtitle");
      const willOpen = $panel.is(":hidden");
      if (willOpen) {
        $btn.find(".faqstoggle-span").html("-");
        $btn.attr("aria-expanded", "true");
      } else {
        $btn.find(".faqstoggle-span").html("+");
        $btn.attr("aria-expanded", "false");
      }
      $panel.slideToggle();
    });
    $(".a-totop").click(function () {
      $jq("html,body").animate(
        {
          scrollTop: $jq(".reward-program-middetails").offset().top - 50 + "px",
        },
        300
      );
    });
    if ($(window).width() > 1000) {
      $(window).scroll(function () {
        $(".animation-box").each(function () {
          if (
            $(window).scrollTop() + ($(window).height() * 2) / 3 >
            $(this).offset().top
          ) {
            $(this).addClass("animate-text");
          } else {
            $(this).removeClass("animate-text");
          }
        });
      });
    }
  });
});
